import {
  CompanyLandingUnderNavHeader,
  CompanyLandingUnderNavSkeletonWrappers,
} from 'components/NavBar/NavBar.styled';
import { Skeleton } from 'components/storybook-migration/skeleton/Skeleton';
import { useDimensions } from 'hooks/useDimensions/useDimensions';
import { useStore } from 'store';

export const CompanySelectorLandingContainer = () => {
  const { isMobileOrTablet } = useDimensions();
  const [appTheme] = useStore((state) => [state.appTheme]);

  return (
    <>
      {isMobileOrTablet ? (
        <CompanyLandingUnderNavHeader $appTheme={appTheme}>
          <CompanyLandingUnderNavSkeletonWrappers>
            <Skeleton width="257px" height="12px" borderRadius="24px" />
            <Skeleton width="80%" height="12px" borderRadius="24px" />
          </CompanyLandingUnderNavSkeletonWrappers>
        </CompanyLandingUnderNavHeader>
      ) : (
        <CompanyLandingUnderNavHeader $appTheme={appTheme}>
          <CompanyLandingUnderNavSkeletonWrappers>
            <Skeleton width="124px" height="12px" borderRadius="24px" />
            <Skeleton width="189px" height="12px" borderRadius="24px" />
          </CompanyLandingUnderNavSkeletonWrappers>
          <CompanyLandingUnderNavSkeletonWrappers>
            <Skeleton width="257px" height="12px" borderRadius="24px" />
            <Skeleton width="393px" height="12px" borderRadius="24px" />
          </CompanyLandingUnderNavSkeletonWrappers>
        </CompanyLandingUnderNavHeader>
      )}
    </>
  );
};
